module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_8.61979f11.png";